module.exports = __webpack_public_path__ + "static/img/wawaBottom2.d31b050.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wawaBottom2.png
// module id = YIZd
// module chunks = 2